import React from 'react';
import { Form as FinalForm } from 'react-final-form';
import PicCardForm, { getPicBlob } from './PicCardForm';
import config from '../../../config';

const { avatarFileName } = config;

export default ({ upload }) => {
    const previewPrefix = 'rider-preview';
    const previewFormat = 'svg';

    const getPreviewSrc = i => `/static/userAvatars/${previewPrefix}/avatar-0${i}.${previewFormat}`;
    const removePreviewPrefix = picPreview =>
        picPreview
            .replace(new RegExp(previewPrefix), 'rider')
            .replace(new RegExp(previewFormat), 'png');

    const uploadAsString = async picPreview => {
        const nonPrefixedPic = removePreviewPrefix(picPreview);

        try {
            const picBlob = await getPicBlob(nonPrefixedPic);
            const formData = new FormData();
            formData.append('file', picBlob, avatarFileName);

            await upload(formData);
        } catch (e) {
            // is handled via onImageUpload thunk
        }
    };

    const defaultImages = Array.from({ length: 7 }, (_, i) => getPreviewSrc(i));

    return (
        <FinalForm
            initialValues={{}}
            onSubmit={() => null}
            render={({ values = {} }) => (
                <PicCardForm
                    pic={values.pic}
                    heading="Avatare"
                    images={defaultImages}
                    onBlobRequest={() => uploadAsString(values.pic)}
                    applySelectedOverlay={false}
                />
            )}
        />
    );
};
